import React from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'

import enhance from './enhancers'

export function ChooseArgument(props) {
  const {
    theme,
    questions,
    handleArgumentClick,
    handleImageLoad,
    imageLoaded
  } = props

  return (
    <div className={theme.chooseArgument}>
      <h1 className={theme.heading}>Choose an Argument</h1>

      {questions.map((question, index) => {
        const [argument] = question.arguments
        const className = classnames(theme.question, {
          [theme.imageLoaded]: imageLoaded
        })

        return (
          <div
              className={className}
              key={index}
              onClick={() => handleArgumentClick(index)}>
            <Link to='/question'>
              <img
                  alt={argument.text}
                  className={theme.questionImage}
                  src={argument.imgUrl}
                  onLoad={handleImageLoad} />
            </Link>
            <h2 className={theme.questionText}>{question.question}</h2>
          </div>
        )
      })}
    </div>
  )
}

export default enhance(ChooseArgument)



// WEBPACK FOOTER //
// ./client/modules/debate/components/ChooseArgument/index.js